import React from "react";
import { VIEW_MODE, ViewMode } from "../../../utils/constants";
import TabSelector from "../../common/TabSelector";

interface ViewModeTabsProps {
  viewMode: ViewMode;
  setViewMode: React.Dispatch<React.SetStateAction<ViewMode>>;
  setPage: React.Dispatch<React.SetStateAction<number>>;
}

const ViewModeTabs: React.FC<ViewModeTabsProps> = ({ viewMode, setViewMode, setPage }) => (
  <TabSelector<"all" | "reportees">
    tabs={[
      { k: "all", label: "All Employees" },
      { k: "reportees", label: "My Reportees" },
    ]}
    active={viewMode === VIEW_MODE.REPORTEES ? "reportees" : "all"}
    onChange={(key) => {
      setViewMode(key === "reportees" ? VIEW_MODE.REPORTEES : VIEW_MODE.ALL);
      setPage(1);
    }}
  />
);

export default ViewModeTabs;

